import { useState, useCallback } from 'react';

/**
 * Manages the enhanced status display for the LiveChat component.
 * Controls the status indicator (listening, processing, ready, etc.)
 * shown to the user during conversation.
 *
 * @returns {{ currentStatus: string, showEnhancedStatus: boolean, showStatus: Function, hideStatus: Function, showEnhancedStatusMessage: Function, hideEnhancedStatus: Function }}
 */
export function useLiveChatStatus() {
  const [currentStatus, setCurrentStatus] = useState('');
  const [showEnhancedStatus, setShowEnhancedStatus] = useState(false);

  const showEnhancedStatusMessage = useCallback((status) => {
    setCurrentStatus(status);
    setShowEnhancedStatus(true);
  }, []);

  const hideEnhancedStatus = useCallback(() => {
    setShowEnhancedStatus(false);
    setCurrentStatus('');
  }, []);

  const showStatus = useCallback((status, duration = null) => {
    showEnhancedStatusMessage(status);
    if (duration) {
      setTimeout(() => {
        hideEnhancedStatus();
      }, duration);
    }
  }, [showEnhancedStatusMessage, hideEnhancedStatus]);

  const hideStatus = useCallback(() => {
    hideEnhancedStatus();
  }, [hideEnhancedStatus]);

  return {
    currentStatus,
    showEnhancedStatus,
    showStatus,
    hideStatus,
    showEnhancedStatusMessage,
    hideEnhancedStatus
  };
}
